<script>
  import LineruTagsService from "../services/lineru-tags";
  import GoogleTagManagerService from "../services/tag-manager";


  function firstCardnavigateTo(idTarget) {
    const target = document.getElementById(idTarget) || document.body;
    const topPos = target.getBoundingClientRect().top + window.pageYOffset - 0;

    GoogleTagManagerService.setTag(LineruTagsService.general().referralApproved);

    scroll({
      top: topPos,
      behavior: "smooth",
    });
  }

  function secondCardNavigateTo(idTarget) {
    const target = document.getElementById(idTarget) || document.body;
    const topPos = target.getBoundingClientRect().top + window.pageYOffset - 0;

    GoogleTagManagerService.setTag(LineruTagsService.general().referNowDiscount);

    scroll({
      top: topPos,
      behavior: "smooth",
    });
  }
</script>

<div
  class="bgr-blue-light pb-18"
  style="background-image: url('images/fold-5/fondo-fold-5.png'); background-repeat: no-repeat"
>
  <div class="container t-lg-center">
    <h2 class="py-10">Los beneficios para ti y tu referido</h2>
    <div class="d-grid grid-1 grid-md-12 gap-8">
      <div class="col-10 col-lg-6 px-4 px-lg-0">
        <div class="card bdr-radius-1 p-5 px-10 px-md-10">
          <div class="t-md-center mt-6 mt-lg-8">
            <h5>Cuando tu referido es aprobado tú:</h5>
          </div>
          <div class="d-grid grid-12 gap-lg-6 mt-8 mt-lg-10 mb-lg-8 px-lg-18">
            <div class="col-12 col-md-3">
              <img src="images/fold-5/1.svg" alt="recibes puntos" />
            </div>
            <div class="col-12 col-md-9 t-left pt-4 px-lg-8">
              <p>
                <strong>Recibes</strong>
                puntos para pedir aumentos en tu cupo
              </p>
            </div>
          </div>
          <div class="d-grid grid-12 gap-lg-8 mt-8 px-lg-18">
            <div class="col-12 col-md-3">
              <img src="images/fold-5/2.svg" alt="ganas puntos" />
            </div>
            <div class="col-12 col-md-9 t-left pt-3 px-lg-8">
              <p>
                Ganas puntos para tener
                <strong>descuentos</strong>
                al pagar
              </p>
            </div>
          </div>
          <div class="d-flex justify-content-center mt-8 mt-lg-4 mt-xl-14">
            <button
              class="btn btn--shadow bgr-primary-500 bgr-brand-2:active t-white btn-lg mb-6 w-100 w-lg-auto d-flex t-left align-items-center"
              on:click={() => firstCardnavigateTo("fold-2")}
              role="button"
              aria-labelledby=""
            >
              <span class="flex-grow">¡Referir ya!</span>
              <svg class="ml-3 -mr-3 t-yellow" width="16" height="11"
                ><path
                  fill="currentColor"
                  d="M15.902 5.257l-5-5.156a.326.326 0 00-.471 0 .351.351 0 000 .486l4.431 4.57H.333A.338.338 0 000 5.5c0 .19.15.344.333.344h14.529l-4.431 4.57a.351.351 0 000 .485.327.327 0 00.471 0l5-5.156a.351.351 0 000-.486z"
                /></svg
              >
              <span class="d-none qwerty" />
            </button>
          </div>
        </div>
      </div>
      <div class="col-10 col-lg-6 px-4 px-lg-0">
        <div class="card bdr-radius-1 p-4 px-10 px-md-10">
          <div class="t-lg-center mt-8">
            <h5>Para comenzar tu referido ya tiene:</h5>
          </div>
          <div class="d-grid grid-12 gap-lg-8 pt-2 px-lg-10">
            <div class="col-12 t-center">
              <img class="img-size mb-3 mb-md-0" src="images/fold-5/40.svg" alt="40%" />
              <h3 class="t-brand-2 -mt-2 mb-5">Descuento en su primer pago</h3>
              <h5 class="pb-3">Aplica en los cargos de interés, administración y seguro.</h5>
            </div>
          </div>
          <div class="d-flex justify-content-center mt-4 mb-1">
            <button
              class="btn btn--shadow bgr-primary-500 bgr-brand-2:active t-white btn-lg mb-6 w-100 w-lg-auto d-flex t-left align-items-center"
              on:click={() => secondCardNavigateTo("fold-2")}
              role="button"
              aria-labelledby=""
            >
              <span class="flex-grow">¡Referir ya!</span>
              <svg class="ml-3 -mr-3 t-yellow" width="16" height="11"
                ><path
                  fill="currentColor"
                  d="M15.902 5.257l-5-5.156a.326.326 0 00-.471 0 .351.351 0 000 .486l4.431 4.57H.333A.338.338 0 000 5.5c0 .19.15.344.333.344h14.529l-4.431 4.57a.351.351 0 000 .485.327.327 0 00.471 0l5-5.156a.351.351 0 000-.486z"
                /></svg
              >
              <span class="d-none qwerty" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .card {
    background: #ffffff;
    box-shadow: 1px 8px 12px 2px #d3d3d3;
  }
  .img-size{
    max-width: 100%;
  }
</style>
